var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpinner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-secondHalf"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-firstHalf"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "spinner-secondHalf-fade",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spinner-secondHalf)",
    strokeWidth: 21,
    d: "M 20 60 A 40 40 0 0 1 102 60"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "spinner-firstHalf-fade",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spinner-firstHalf)",
    strokeWidth: 21,
    d: "M 102 60 A 40 40 0 0 1 20 60"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 60 A 40 40 0 0 1 102 60",
    strokeLinecap: "square",
    stroke: "currentColor",
    mask: "url(#spinner-secondHalf-fade)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 102 60 A 40 40 0 0 1 20 60",
    strokeLinecap: "square",
    stroke: "currentColor",
    mask: "url(#spinner-firstHalf-fade)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M 20 60 A 96 96 0 0 1 20 58"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spinner.a234e48ea80244783c58c83dcf6736c7.svg";